<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsIncidentReportService.showDetailedView"
         [ngStyle]="{width: settingsIncidentReportService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Incident Report Settings'"
                            [buildings]="settingsIncidentReportService.buildingsForRead"></filter>
                </div>

                <div *ngIf="settingsIncidentReportService.canEdit()" class="col-sm-5">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="settingsIncidentReportService.showCreateModal = true">
                        <i class="fa fa-plus-circle"></i> New Setting
                    </button>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allIncidentReportsSettings'"
                          [ngClass]="{'sk-loading': settingsIncidentReportService.spinnerShow}">
                    <settings-incident-report-list></settings-incident-report-list>
                    <spinner [spinnerShow]="settingsIncidentReportService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsIncidentReportService.data.allIncidentReportsSettings.total && urlService.queryParams['page']"
                            [total]="settingsIncidentReportService.data.allIncidentReportsSettings.total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <detailed-view *ngIf="settingsIncidentReportService.showDetailedView"></detailed-view>
    </div>
</div>

<!-- MODALS -->
<notification-modal *ngIf="settingsIncidentReportService.isNotificationModalShow"></notification-modal>
<settings-incident-report-modal *ngIf="settingsIncidentReportService.showCreateModal"></settings-incident-report-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/settings-incident-report.component.html